import { styled } from 'styled-components';
import { MEDIA_WIDTHS } from '../../theme/Theme';

export const Wrapper = styled.div`
    width: 100%;
    // background-image: url(https://img.freepik.com/free-vector/flat-geometric-background_23-2148957201.jpg?w=1380&t=st=1684311365~exp=1684311965~hmac=07c1ba7461cad1124dff405d576757d8b0202df05f0f0dc4ff7796556b0e8f41);
    background-repeat: no-repeat;
    background-size: cover;
    background-attachment: fixed;
    position: relative;
    background: white;
    .body-frame {
        width: 100%;
        min-height: 100vh;
        background: transparent;
    }
    @media screen and (max-width: ${MEDIA_WIDTHS.upToSmall}px) {
        background-image: none;
        background: white;
    }
`;
